import React, { useState, useEffect, useCallback } from 'react'
// import { confirm } from "@/components/Modal";
import { enqueueNotification } from '../Notifications'
import { SocketMessageData, SocketMessage, ForwardingConfigDetails, UnReadNotify } from '@/types'
import { useSocket } from '@/hooks/useSocket'
import { getUnReadCount, getConfigList } from '@/api'
import { useQuery } from '@tanstack/react-query'

export interface NotificationContextProps {
  notificatioinData: SocketMessageData
  updateNotificatioinData: React.Dispatch<React.SetStateAction<SocketMessageData>>
  refetchUnReadNumber: () => void
  unreadCount: UnReadNotify
}

const formatMessage = (message: unknown) => {
  let msg: unknown = message
  if (typeof message === 'string') {
    try {
      msg = JSON.parse(message)
    } catch (e) {
      console.error(e)
    }
    return msg
  }
  return message
}

export const NotificationContext = React.createContext({} as NotificationContextProps) // 创建一个 Context 对象

export const NotificationProvider = ({ children }: { children: React.ReactNode }) => {
  const socket = useSocket() as SocketClient
  const [data, setData] = useState<SocketMessageData>({
    total_number: 0,
    app_total_number: 0,
    plat_total_number: 0,
    connected: false,
  }) // 组件的状态用来存储数据

  const [pushConfig, setPushConfig] = useState<{
    enabled: boolean
    orgs: string[]
    apps: string[]
    // @ts-ignore
  }>({ enabled: false, orgs: null, apps: null })
  const queryUnRead = useQuery(['getUnReadCount'], getUnReadCount, {
    onSuccess: (res) => {
      setData((oldData) => ({
        ...oldData,
        total_number: res?.total_number ?? 0,
        app_total_number: res?.app_total_number ?? 0,
        plat_total_number: res?.plat_total_number ?? 0,
      }))
    },
  })
  const pushNotification = enqueueNotification()

  useQuery(['getConfigList'], () => getConfigList({ page: 1, size: 10 }), {
    onSuccess: (res) => {
      const config = res?.detail?.[0] as ForwardingConfigDetails
      pushConfig.enabled = config?.enabled === 1
      // @ts-ignore
      pushConfig.orgs = config?.org_ids?.map((org) => org?.toString())
      // @ts-ignore
      pushConfig.apps = config?.app_ids?.map((app) => app?.toString())
      // setPushConfig({
      //   enabled: config?.enabled === 1,
      //   orgs: config?.org_ids?.map((org) => org?.toString()),
      //   apps: config?.app_ids?.map((app) => app?.toString()),
      // });
    },
  })

  const updateConnectionStatus = useCallback((connected: boolean) => {
    setData((oldData) => ({
      ...oldData,
      connected,
    }))
  }, [])

  useEffect(() => {
    // 监听名为 'data' 的事件，当接收到数据时，更新组件的状态
    if (socket) {
      socket?.on('connect', () => {
        updateConnectionStatus(socket.connected)
      })
      socket?.on('message', (data: string) => {
        const res = formatMessage(data) as SocketMessage<'invite' | 'remove' | 'test' | 'alert'>
        if (typeof res !== 'string' && res?.type === 'alert') {
          const messageAppid = res?.content?.send_id?.toString()
          const messageOrgid = res?.content?.org_id?.toString()

          if (pushConfig?.enabled) {
            if (!pushConfig.apps && !pushConfig.orgs) {
              //no orgs & apps
              pushNotification(res?.content)
            } else if (
              !pushConfig.apps &&
              // @ts-ignore
              pushConfig.orgs?.includes(messageOrgid)
            ) {
              //no apps
              pushNotification(res?.content)
            } else if (!pushConfig?.orgs && pushConfig?.apps?.includes(messageAppid)) {
              //no orgs
              pushNotification(res?.content)
            } else if (
              // @ts-ignore
              pushConfig.orgs?.includes(messageOrgid) &&
              pushConfig?.apps?.includes(messageAppid)
            ) {
              //apps & orgs
              pushNotification(res?.content)
            }
          }
        } else if (typeof res !== 'string') {
          pushNotification(res?.content)
        }
        // queryUnRead.refetch();
        if (res.type === 'invite' || res.type === 'remove') {
          socket?.emit(
            'message',
            JSON.stringify({
              type: res.type,
              org_id: res?.content?.sender_id,
            }),
          )
        }
      })
      socket?.on('notify', (data: string) => {
        const res = formatMessage(data) as SocketMessage<'unread' | 'station-msg'>
        if (typeof res !== 'string' && res?.type === 'station-msg') {
          const content = (res as SocketMessage<'station-msg'>)?.content
          pushConfig.enabled = content?.status === '1'
          // @ts-ignore
          pushConfig.apps = content?.apps
          // @ts-ignore
          pushConfig.orgs = content?.orgs
        }
        if (typeof res !== 'string' && res?.type === 'unread') {
          const content = (res as SocketMessage<'unread'>)?.content
          setData((oldData) => ({
            ...oldData,
            total_number: content?.total_number ?? 0,
            app_total_number: content?.app_total_number ?? 0,
            plat_total_number: content?.plat_total_number ?? 0,
          }))
        }
      })
      socket?.on('disconnect', () => {
        updateConnectionStatus(socket.connected)
      })
    }

    // 在组件卸载时断开 socket 连接
    return () => {
      // if (socket) socket?.disconnect();
    }
    //eslint-disable-next-line
  }, [socket?.ids])
  // 将 data 和一个 setter 函数作为 value 值提供给所有使用此 Context 的子组件
  return (
    <NotificationContext.Provider
      value={{
        notificatioinData: data,
        updateNotificatioinData: setData,
        refetchUnReadNumber: queryUnRead?.refetch,
        // @ts-ignore
        unreadCount: queryUnRead?.data,
      }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
